function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "BTN_Loeschen",
  transform: "translate(0 0.134)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "HG",
  width: 26,
  height: 29,
  transform: "translate(0 -0.134)",
  fill: "#fff",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Pfad_95",
  "data-name": "Pfad 95",
  transform: "translate(4.784 10.983)",
  fill: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 13.45984077453613 15.43169593811035 L 3.501905202865601 15.43169593811035 L 1.17421543598175 0.9999960660934448 L 15.78753089904785 0.9999960660934448 L 13.45984077453613 15.43169593811035 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 2.348427772521973 1.999996185302734 L 4.353537559509277 14.43169593811035 L 12.60820865631104 14.43169593811035 L 14.61331844329834 1.999996185302734 L 2.348427772521973 1.999996185302734 M 3.814697265625e-06 -3.814697265625e-06 L 16.96174240112305 -3.814697265625e-06 L 14.31147289276123 16.43169593811035 L 2.650273323059082 16.43169593811035 L 3.814697265625e-06 -3.814697265625e-06 Z",
  stroke: "none",
  fill: "#ffe666"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rechteck_118",
  "data-name": "Rechteck 118",
  transform: "translate(2.663 7.336)",
  fill: "#fff",
  stroke: "#ffe666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 20.85,
  height: 5.406,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 18.85,
  height: 3.406,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rechteck_119",
  "data-name": "Rechteck 119",
  transform: "translate(11.158 3.475)",
  fill: "#fff",
  stroke: "#ffe666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 4.633,
  height: 5.406,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 2.633,
  height: 3.406,
  fill: "none"
})));

function SvgBtnLoeschen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLoeschen);
export default __webpack_public_path__ + "static/media/BTN_Loeschen.9c7ef7c10bc09449db701a58f78f0e53.svg";
export { ForwardRef as ReactComponent };